import { render, staticRenderFns } from "./book-cate-selector.vue?vue&type=template&id=1e68aad2"
import script from "./book-cate-selector.vue?vue&type=script&lang=ts"
export * from "./book-cate-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports